export default __webpack_public_path__ + "static/media/b6.61b7a4ab.png";